import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyD7MMelcJoqDVkh-nKGeTxeKJhkqCIIi1w",
  authDomain: "planmaster-ccf07.firebaseapp.com",
  projectId: "planmaster-ccf07",
  storageBucket: "planmaster-ccf07.firebasestorage.app",
  messagingSenderId: "655704691057",
  appId: "1:655704691057:web:4ca7aa84ede4ee075866d0",
  measurementId: "G-J8NBM7N5B9"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, auth, db, storage, firebaseConfig };
